export const routes = {
  landingPage: '/',
  channels: '/channels',
  channelsPage: '/channels/:channelId',
  gotoChannelsPage: (channelId) => `/channels/${channelId}`,
};
